<template>
  <div class="previewStaging">
    <div class="pageContent">
      <heading type="h1">Preview and Staging</heading>
      <div class="row">
        <div class="col-md-6">
          <img class="previewStaging__img" src="http://via.placeholder.com/300x250" />
          <div class="previewStaging__cta">
            <button-cta class="btn-block btn-success no-border" :onClick="approve" :style="`border-radius: 0`">Approve</button-cta>
            <button-cta class="btn-block btn-danger" :onClick="decline" :style="`border-radius: 0; margin: 0`">Decline</button-cta>
          </div>
          <notifications :messages="notifications"></notifications>
        </div>
        <div class="col-md-6">
          <heading type="h2">Client Comments</heading>
          <client-comments />
          <div class="previewStaging__save">
              <button-cta class="btn btn-primary" :onClick="save">Save files to FTP server</button-cta>
              <button-cta class="btn btn-primary" :onClick="share">Share</button-cta>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ClientComments from '@/components/ClientComments/client-comments'
import ButtonCta from '@/components/Button/button'

export default {
  name: 'preview_staging',
  components: {
    ClientComments,
    Heading,
    ButtonCta
  },
  data: () => ({
  }),
  methods: {
    save () {
      console.log('Save.')
    },
    share () {
      console.log('Share.')
    },
    approve () {
      const message = 'Thanks for that, feel free to drop us a line with some feedback or notes.'
      const notification = [ { type: 'success', message: { title: 'All set and good to go!', body: message } } ]
      this.notifications = message ? notification : null
    },
    decline () {
      const message = 'We are sorry you are not happy with the result, would you mind dropping us a line with some feedback, please?'
      const notification = [ { type: 'danger', message: { title: '', body: message } } ]
      this.notifications = message ? notification : null
    }
  }
}
</script>

<style lang="scss">
    .previewStaging {
      &__img {
        width: 100%;
        max-width: 100%;
      }
      &__cta {
        display: flex;
        margin-bottom: 30px;
      }
      &__save {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/preview-staging.vue